import { getWithRedirect } from 'utils/axios'
import { SettingRow } from 'types/GlobalSimFlaw'

import {
  TGetSimFlawGroupsQueryParams,
  TSimFlawAggregatesDto,
  TSimFlawGroupsDto
} from './contract'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const FLAW_GROUPS_URL = `${BASE_URL}v1/internal/sim-flaw-groups`
const FLAW_AGGREGATES_URL = `${BASE_URL}v1/internal/sim-flaw-aggregates`
const FLAW_SETTINGS_URL = `${BASE_URL}v1/internal/sim-flaw-settings`

function buildQuery(params: Record<string, string | undefined>) {
  const search = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      search.append(key, value)
    }
  })

  const query = search.toString()

  return query ? `?${query}` : ''
}

/**
 * Brister grouped by source table. Omitting `customer_id` returns every
 * customer, which is this page's default; `'null'` is the Demo tenant.
 */
export async function getSimFlawGroups(
  params: TGetSimFlawGroupsQueryParams = {}
) {
  return getWithRedirect<TSimFlawGroupsDto>(
    `${FLAW_GROUPS_URL}${buildQuery({ ...params })}`
  )
}

export async function getSimFlawAggregates(customerId?: string) {
  return getWithRedirect<TSimFlawAggregatesDto>(
    `${FLAW_AGGREGATES_URL}${buildQuery({ customer_id: customerId })}`
  )
}

export async function getSimFlawSettings() {
  return getWithRedirect<SettingRow[]>(FLAW_SETTINGS_URL)
}
